import React, { useState, useEffect } from "react";
import { Col, Row, Pagination } from "antd";
import Request from "../../helpers/Request";
import ReviewCard from "./components/ReviewCard";
import type { Review } from "./components/ReviewCard";

const MobileReviewsSection = () => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const pageSize = 4; // Number of reviews to display per page

  useEffect(() => {
    Request("../reviews_list", "GET").then((response) => {
      setReviews(response.data);
    });
  }, []);

  // Calculate the start and end index for reviews to display on the current page
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  }

  return (
    <>
      {reviews.length > 0 && (
        <div className="reviews-section">
          <Row gutter={[16, 16]}>
            {reviews.slice(startIndex, endIndex).map((review, index) => (
              <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
                <ReviewCard review={review} />
              </Col>
            ))}
          </Row>
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={reviews.length}
            onChange={handlePageChange}
            showSizeChanger={false}
            style={{
              marginTop: 20,
              textAlign: "center",
            }}
          />
        </div>
      )}
    </>
  );
};

export default MobileReviewsSection;
